import * as React from 'react';

import { clsx } from 'clsx';

import * as styles from './SearchBlock.css';
import { Label } from '@cian/ui-kit';

interface ISearchBlockProps {
  backgroundNode: React.ReactNode;
  adBanner: React.ReactNode;
  isNewFilters: boolean;
  section: string;
  label?: string;
  isRedesignEnabled: boolean;
}

export const SearchBlock: React.FC<React.PropsWithChildren<ISearchBlockProps>> = ({
  backgroundNode,
  adBanner,
  children,
  isNewFilters,
  section,
  label,
  isRedesignEnabled,
}) => {
  const isDailyRent = section === 'daily-rent';

  return (
    <div
      data-testid="SearchBlock"
      className={clsx(
        styles['c-filters'],
        isNewFilters && styles['c-filters--new'],
        isDailyRent && styles['c-filters-dailyrent'],
      )}
    >
      <div className={styles['c-filters-content']}>
        <div className={clsx(styles['c-filters-inner'], isRedesignEnabled && styles['redesign'])}>
          {children}
          {!isRedesignEnabled && adBanner}
        </div>
      </div>
      <div className={styles['background']}>{backgroundNode}</div>
      {label && (
        <div className={styles['label']}>
          <Label>{label}</Label>
        </div>
      )}
      {isRedesignEnabled && <div className={styles['ad-banner']}>{adBanner}</div>}
    </div>
  );
};
